module.exports = __webpack_public_path__ + "img/hr-H-B-5-load-connect-shadow.016c8c3b.png";